<app-loader *ngIf="isLoading"></app-loader>

<div class="container-fluid">
  <div class="row">
    <div class="d-flex justify-content-start col-12 col-sm-4 ps-0 mb-3 mb-md-0">
      <app-main-heading>
        <span title>{{ "SIDEBAR.ACTIVITYHISTORY" | translate }}</span>
      </app-main-heading>
    </div>
    <div class="col-12 col-sm-8 pe-3  ps-0 ps-md-3 pe-md-3">
      <div class="d-block d-md-none">
        <div class="justify-content-start justify-content-md-end align-items-center flex-nowrap buttonAlignFilter">
          <div class="" *ngIf="curentUser.roleType != 'MEMBERS'">
            <ng-select #userSelectMobileView class="bg-transparent custom w-100" [items]=" userResponse"
              [(ngModel)]="user" bindLabel="name" bindValue="id" [clearable]=false [searchable]=false
              (ngModelChange)="getUserDevices($event)">
              <ng-template class="text-truncate custom" ng-label-tmp let-item="item">
                <span class="ps-2">{{item?.name?.length > 15 ?item?.name.slice(0,15) + "..." : item?.name}}</span>
              </ng-template>
              <ng-template class="text-truncate custom" ng-option-tmp let-item="item" let-index="index">
                <span title={{item?.name}}>{{ item?.name.length > 15 ? item?.name.slice(0,15) + "..." :
                  item?.name}}</span>
              </ng-template>
            </ng-select>
          </div>
          <div class="">
            <ng-select #deviceSelectMobileView [dropdownPosition]="'bottom'" class="bg-transparent custom w-100"
              [items]="devicesList" [(ngModel)]="device" bindLabel="deviceName" bindValue="id" [clearable]=false
              [searchable]=false (ngModelChange)="getAllActivityuser($event)">
              <ng-template class="text-truncate custom" ng-label-tmp let-item="item">
                <span class="ps-2">{{item?.deviceName?.length > 15 ?item?.deviceName.slice(0,15) + "..." :
                  item?.deviceName}}</span>
              </ng-template>
              <ng-template class="text-truncate custom" ng-option-tmp let-item="item" let-index="index">
                <span title={{item?.deviceName}}>{{ item?.deviceName.length > 15 ? item?.deviceName.slice(0,15) + "..."
                  :
                  item?.deviceName}}</span>
              </ng-template>
            </ng-select>
          </div>
          <div class="">
            <button [ngClass]="filterClass" class="h-40" (click)="showFilters()">
              <img [src]="'ACTIVITYHISTORY.FILTERIMG' | translate" alt="" *ngIf="whitefilter" />
              <img [src]="'ACTIVITYHISTORY.GRAYFILTER' | translate" alt="" *ngIf="grayfilter" />
              <span *ngIf="totalFIlterCountVal">({{ totalFIlterCount }})</span>
            </button>
          </div>
        </div>
      </div>
      <div class="d-none d-md-block">
        <div class="d-flex justify-content-start justify-content-md-end align-items-center flex-wrap">
          <div class="me-sm-2 me-md-3 me-3" *ngIf="curentUser.roleType != 'MEMBERS'">
            <ng-select #userSelect class="bg-transparent custom w-100" [items]=" userResponse" [(ngModel)]="user"
              bindLabel="name" bindValue="id" [clearable]=false [searchable]=false
              (ngModelChange)="getUserDevices($event)">
              <ng-template class="text-truncate custom" ng-label-tmp let-item="item">
                <img height="15" width="15" src="assets/images/Vector 651usericon.svg" />
                <span class="ps-2">{{item?.name?.length > 15 ?item?.name.slice(0,15) + "..." : item?.name}}</span>
              </ng-template>
              <ng-template class="text-truncate custom" ng-option-tmp let-item="item" let-index="index">
                <span title={{item?.name}}>{{ item?.name.length > 15 ? item?.name.slice(0,15) + "..." :
                  item?.name}}</span>
              </ng-template>
            </ng-select>
          </div>
          <div class="">
            <ng-select #deviceSelect [dropdownPosition]="'bottom'" class="bg-transparent custom w-100"
              [items]="devicesList" [(ngModel)]="device" bindLabel="deviceName" bindValue="id" [clearable]=false
              [searchable]=false (ngModelChange)="getAllActivityuser($event)">
              <ng-template class="text-truncate custom" ng-label-tmp let-item="item">
                <img height="15" width="15" src="assets/images/mbl-sm.png" />
                <span class="ps-2">{{item?.deviceName?.length > 15 ?item?.deviceName.slice(0,15) + "..." :
                  item?.deviceName}}</span>
              </ng-template>
              <ng-template class="text-truncate custom" ng-option-tmp let-item="item" let-index="index">
                <span title={{item?.deviceName}}>{{ item?.deviceName.length > 15 ? item?.deviceName.slice(0,15) + "..."
                  :
                  item?.deviceName}}</span>
              </ng-template>
            </ng-select>
          </div>
          <div class="ms-0 ms-md-3  ">
            <button [ngClass]="filterClass" class="h-40 " (click)="showFilters()">
              <img [src]="'ACTIVITYHISTORY.FILTERIMG' | translate" alt="" *ngIf="whitefilter" />
              <img [src]="'ACTIVITYHISTORY.GRAYFILTER' | translate" alt="" *ngIf="grayfilter" />
              <span *ngIf="totalFIlterCountVal">({{ totalFIlterCount }})</span>
            </button>
          </div>
        </div>
      </div>
      <div class="filterDiv" *ngIf="isShowFilter">
        <div class="mb-2">
          <h5 class="fw-bold">
            {{ "ACTIVITYHISTORYMAIN.FILTERS" | translate }}
          </h5>
          <div class="mb-2 mt-2">
            <label for="status" class="q-form-label">{{"ACTIVITYHISTORYMAIN.STATUS" | translate}} </label>
            <div class="row">
              <div class="col-6 col-sm-4" *ngFor="let item of filterArr; let i = index">
                <div class="d-flex my-1">
                  <div>
                    <label class="terms-checkbox">
                      <input (change)="statusChange(item, $event)" [(ngModel)]="item.isChecked" [value]="item.value"
                        type="checkbox" class="form-control p-0" />
                      <span class="checkmark"></span>
                    </label>
                  </div>
                  <div>{{ item.filterStatus }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="mb-2 mt-2">
            <label for="status" class="q-form-label">{{
              "ACTIVITYHISTORYMAIN.ACTION" | translate
              }}</label>
            <div class="row">
              <div class="col-6 col-sm-4" *ngFor="let item of actionValue; let i = index">
                <div>
                  <div class="d-flex my-1">
                    <div *ngIf="item.action?.length != 0">
                      <label class="terms-checkbox">
                        <input (change)="actionChange(item, $event)" [(ngModel)]="item.isChecked" [value]="item.value"
                          type="checkbox" class="form-control p-0" />
                        <span class="checkmark"></span>
                      </label>
                    </div>
                    <div>{{ item.action }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mb-2 mt-2">
            <label for="status" class="q-form-label">{{
              "ACTIVITYHISTORYMAIN.DATEANDTIME" | translate
              }}</label>
            <div class="row">
              <div class="col-6">
                <div class="form-group">
                  <label class="mb-2" for="">{{
                    "ACTIVITYHISTORYMAIN.FROMDATE" | translate
                    }}</label>
                  <div>
                    <input type="date" class="q-form-control form-control date-black" [min]="startMin" [max]="maxDate"
                      [ngModel]="startDate | date: 'yyyy-MM-dd'" (ngModelChange)="setDate($event)" name="startdate"
                      id="date" />
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <label class="mb-2" for="">{{
                    "ACTIVITYHISTORYMAIN.TODATE" | translate
                    }}</label>
                  <div>
                    <input type="date" class="q-form-control form-control date-black"
                      [ngModel]="endDate | date: 'yyyy-MM-dd'" (ngModelChange)="EndDate($event)" [min]="minDate"
                      [max]="maxDate" name="endDate" id="date" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row my-3">
            <div class="col-6">
              <button class="submit-btn bg-orgclr w-100" [disabled]="!disableFilter" [ngClass]="
                  disableFilter == false? 'q-invalid-button  ': 'submit-btn bg-orgclr '" (click)="Filter()">
                {{ "ACTIVITYHISTORYMAIN.APPLY" | translate }}
              </button>
            </div>
            <div class="col-6">
              <button type="button" class="cancel-btn bg-cancelbtn w-100" (click)="reset()">
                {{ "ACTIVITYHISTORYMAIN.CLEAR" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-3 mb-5" (click)="isShowFilter=false;">
    <div class="table-responsive px-0 mb-3">
      <table class="table activity-table act-history mb-0" aria-describedby="Summary">
        <thead class="activity-header">
          <tr>
            <th scope="col" (click)="sortTable('user_id')" class="cursor-pointer">
              {{ "ACTIVITYHISTORYMAIN.USER" | translate }}
              <span>
                <img
                  [src]="ActivityDto.sort=='ASC'&&ActivityDto.field== 'user_id' ?('ACTIVITYHISTORY.SORTASCIMG' | translate):ActivityDto.sort=='DESC' &&ActivityDto.field== 'user_id'?('ACTIVITYHISTORY.SORTDSCIMG' | translate):('ACTIVITYHISTORY.SORTIMG' | translate)"
                  alt="sort">
              </span>
            </th>
            <th scope="col" (click)="sortTable('objectId')" class="cursor-pointer">{{
              "ACTIVITYHISTORYMAIN.DEVICE" |
              translate }}
              <span>
                <img
                  [src]="ActivityDto.sort=='ASC' &&ActivityDto.field== 'objectId'?('ACTIVITYHISTORY.SORTASCIMG' | translate):ActivityDto.sort=='DESC'  &&ActivityDto.field== 'objectId'?('ACTIVITYHISTORY.SORTDSCIMG' | translate):('ACTIVITYHISTORY.SORTIMG' | translate)"
                  alt="sort">
              </span>
            </th>
            <th scope="col" (click)="sortTable('action')" class="cursor-pointer">{{ "ACTIVITYHISTORYMAIN.ACTION"|
              translate }}
              <span>
                <img
                  [src]="ActivityDto.sort=='ASC'  &&ActivityDto.field== 'action'?('ACTIVITYHISTORY.SORTASCIMG' | translate):ActivityDto.sort=='DESC'  &&ActivityDto.field== 'action'?('ACTIVITYHISTORY.SORTDSCIMG' | translate):('ACTIVITYHISTORY.SORTIMG' | translate)"
                  alt="sort">
              </span>
            </th>
            <th scope="col" (click)="sortTable('notes')" class="cursor-pointer">{{
              "ACTIVITYHISTORYMAIN.DESCRIPTION" | translate }}
              <span>
                <img
                  [src]="ActivityDto.sort=='ASC'  &&ActivityDto.field== 'notes'?('ACTIVITYHISTORY.SORTASCIMG' | translate):ActivityDto.sort=='DESC'  &&ActivityDto.field== 'notes'?('ACTIVITYHISTORY.SORTDSCIMG' | translate):('ACTIVITYHISTORY.SORTIMG' | translate)"
                  alt="sort">
              </span>
            </th>
            <th scope="col" (click)="sortTable('date')" class="cursor-pointer">{{
              "ACTIVITYHISTORYMAIN.DATEANDTIME" | translate }}
              <span>
                <img
                  [src]="ActivityDto.sort=='ASC'  &&ActivityDto.field== 'date'?('ACTIVITYHISTORY.SORTASCIMG' | translate):ActivityDto.sort=='DESC'  &&ActivityDto.field== 'date'?('ACTIVITYHISTORY.SORTDSCIMG' | translate):('ACTIVITYHISTORY.SORTIMG' | translate)"
                  alt="sort">
              </span>
            </th>
            <th scope="col" (click)="sortTable('status')" class="text-center cursor-pointer">
              {{ "ACTIVITYHISTORYMAIN.STATUS" | translate }}
              <span>
                <img
                  [src]="ActivityDto.sort=='ASC'  &&ActivityDto.field== 'status'?('ACTIVITYHISTORY.SORTASCIMG' | translate):ActivityDto.sort=='DESC'  &&ActivityDto.field== 'status'?('ACTIVITYHISTORY.SORTDSCIMG' | translate):('ACTIVITYHISTORY.SORTIMG' | translate)"
                  alt="sort">
              </span>
            </th>
          </tr>
        </thead>
        <tbody *ngIf="allActivity?.length != 0">
          <tr *ngFor="let item of allActivity" class="text-capitalize">
            <td style="margin-top: 40px !important">
              <div class="ellipsisWebsite-activity" title="{{ item.user }}">{{ item.user}}</div>
            </td>
            <td>
              <div class="ellipsisWebsite-activity" title="{{ item.deviceName }}">{{ item.deviceName }}</div>
            </td>
            <td>
              {{ item.action }}
            </td>
            <td>
              <ng-container
                *ngIf="getErrorCodeType(item.notes) === 'SHOW DETAILS' && item.status !== 'Success'; else showNotes">
                <p class="signuptxt mb-0" (click)="getErrorCodeDescription(item.notes, item.statusParam)">
                  {{ 'ACTIVITYHISTORYMAIN.SHOWDETAILS' | translate }}
                </p>
              </ng-container>

              <ng-template #showNotes>
                <ng-container *ngIf="!(getErrorCodeType(item.notes) === 'SHOW DETAILS' && item.status === 'Success')">
                  {{ item.notes }}
                </ng-container>
              </ng-template>
            </td>

            <td>
              {{ item.date }}
            </td>
            <td class="text-center">
              <span class="badge badge-pill rounded-border-radius text-capitalize" [ngClass]="getStatus(item.status)">
                {{ item.status }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="d-flex flex-wrap justify-content-between align-items-center p-0" *ngIf="allActivity?.length != 0">
      <div class="d-flex flex-wrap align-items-center mb-3 mb-sm-0">
        <div class="me-2">
          <h6 class="mb-0 fw-bold">{{ "ACTIVITYHISTORYMAIN.SHOW" | translate }}</h6>
        </div>
        <div>
          <select class="rounded-8 paginationSelect bg-white fw-bold" name="records" [(ngModel)]="pageSize" id="records"
            (ngModelChange)="pageSizeList($event)">
            <option value="10">{{ "ACTIVITYHISTORYMAIN.10" | translate }}</option>
            <option value="25">{{ "ACTIVITYHISTORYMAIN.25" | translate }}</option>
            <option value="50">{{ "ACTIVITYHISTORYMAIN.50" | translate }}</option>
            <option value="100">{{ "ACTIVITYHISTORYMAIN.100" | translate }}</option>
          </select>
        </div>
      </div>
      <div class="p-0 paginationDiv">
        <ngb-pagination [collectionSize]="totalItemsTemp" [maxSize]="2" [rotate]="true" [(page)]="currentPage"
          (pageChange)="pagechanged($event)" [boundaryLinks]="true"></ngb-pagination>
      </div>
    </div>
    <div class="row bg-white mt-3 p-3 justify-content-center text-center rounded-25" style="margin: 0px"
      *ngIf="allActivity?.length === 0">
      <div class="col-md-12">
        <div class="nodatafounddiv">
          <img [src]="'IMAGES.NORECORDFOUNDIMG' | translate" class="img-fluid" alt="" />
          <h1 class="mt-4">
            <app-main-heading>
              <span title>{{ "ACTIVITYHISTORY.NODATAFOUND" | translate }}</span>
            </app-main-heading>
          </h1>
        </div>
      </div>
    </div>
  </div>
</div>



<div class="modal mx-auto fade fixed top-0 left-0 w-100 h-100 outline-none overflow-y-auto" id="errCodeDescModal"
  data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel"
  aria-hidden="true">
  <div class="modal-dialog relative w-auto pointer-events-none modal-dialog-centered">
    <div
      class="modal-content border-none shadow-lg relative text-center p-4 rounded-25 w-100 pointer-events-auto bg-white outline-none">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h5 class="fw-bold mb-0">
            {{ "ACTIVITYHISTORYMAIN.SHOWDETAILS" | translate }}
          </h5>
        </div>
        <div class="cursor-pointer">
          <img [src]='"IMAGES.CLOSE" | translate ' alt="" (click)="closeModal()" data-dismiss="modal" width="15">
        </div>
      </div>
      <div class="text-start" *ngIf="otherErrorCodes?.length != 0">
        <ul>
          <li *ngFor="let errorCode of otherErrorCodes">{{getI18nAsErrorCode(errorCode)}} </li>
        </ul>
      </div>

      <div class="text-start" *ngIf="errorCodeReponse != null">
        <div *ngFor="let code of errorCodeReponse">
          <h6 class="fw-bold">{{code.type}}</h6>

          <ul>
            <li *ngFor="let errorCode of code.errorCodes">{{getI18nAsErrorCode(errorCode)}} </li>
          </ul>
        </div>

      </div>
      <div class="row ps-2">
        <button type="button" class="cancel-btn bg-cancelbtn col-3" (click)="closeModal()">
          {{ "ACTIVITYHISTORYMAIN.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>